import { Base } from '@gandi/ui';
import { StatusIcon } from './StatusIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "OrderStatusHeader-root_10rS9",
  "markdownContent": "OrderStatusHeader-markdownContent_q8WH7"
};
export function OrderStatusHeader({
  icon,
  title,
  content
}) {
  const currentContent = typeof content !== 'string' ? {
    dangerouslySetInnerHTML: content
  } : {
    children: content
  };
  return /*#__PURE__*/_jsxs(Base, {
    flex: true,
    flexAlignItemsCenter: true,
    flexWrap: true,
    className: styles.root,
    children: [/*#__PURE__*/_jsx(StatusIcon, {
      iconName: icon
    }), /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexCol: true,
      gap: "spacing-1x",
      children: [/*#__PURE__*/_jsx(Base, {
        weight: "semibold",
        tagName: "p",
        size: "bigger",
        margin: "none",
        children: title
      }), /*#__PURE__*/_jsx(Base, {
        tagName: "p",
        margin: "none",
        className: styles.markdownContent,
        ...currentContent
      })]
    })]
  });
}